import { atom } from 'jotai';

export const debugAtom = atom(false);
